"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockchainUtilsService = void 0;
var tsyringe_1 = require("tsyringe");
var configurationService_1 = require("../configurationService/configurationService");
var utilsService_1 = require("../utilService/utilsService");
var walletService_1 = require("../walletService/walletService");
var web3Service_1 = require("../web3Service/web3Service");
var BlockchainUtilsService = /** @class */ (function () {
    function BlockchainUtilsService(web3Service, configurationService, utilsService, walletService) {
        var _this = this;
        this.web3Service = web3Service;
        this.configurationService = configurationService;
        this.utilsService = utilsService;
        this.walletService = walletService;
        /**
         * Cancel transaction from nonce to another nonce (both included)
         * @param {{fromNonce: number; toNonce?: number; gas?: number; gasPrice?: number}} parameters
         * @returns {Promise<void>}
         */
        this.cancelTransactions = function (parameters) { return __awaiter(_this, void 0, void 0, function () {
            var fromNonce, toNonce, gas, gasPrice, results, numberOfI, i, signedTransaction, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fromNonce = parameters.fromNonce, toNonce = parameters.toNonce, gas = parameters.gas, gasPrice = parameters.gasPrice;
                        toNonce = toNonce || fromNonce;
                        results = [];
                        gasPrice = gasPrice ||
                            this.configurationService.arianeeConfiguration.transactionOptions.gasPrice * 1.5;
                        gas = gas ||
                            this.configurationService.arianeeConfiguration.transactionOptions.gas;
                        numberOfI = toNonce - fromNonce;
                        i = 0;
                        _a.label = 1;
                    case 1:
                        if (!(i <= numberOfI)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.walletService.signTransaction({
                                value: '0',
                                to: this.walletService.address,
                                gas: gas,
                                gasPrice: gasPrice,
                                nonce: fromNonce + i
                            })];
                    case 2:
                        signedTransaction = _a.sent();
                        return [4 /*yield*/, this.web3Service.web3.eth
                                .sendSignedTransaction(signedTransaction.rawTransaction)];
                    case 3:
                        result = _a.sent();
                        results.push(result);
                        _a.label = 4;
                    case 4:
                        i++;
                        return [3 /*break*/, 1];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
    }
    BlockchainUtilsService = __decorate([
        (0, tsyringe_1.injectable)(),
        __metadata("design:paramtypes", [web3Service_1.Web3Service,
            configurationService_1.ConfigurationService,
            utilsService_1.UtilsService,
            walletService_1.WalletService])
    ], BlockchainUtilsService);
    return BlockchainUtilsService;
}());
exports.BlockchainUtilsService = BlockchainUtilsService;
//# sourceMappingURL=blockchainUtilsService.js.map